import React, {useRef} from 'react';

import useOnMount from 'ui-library/hooks/useOnMount';
import Modal from 'ui-library/modals/Modal';
import * as keyboard from 'util/Keyboard';

interface CopyTextModalProps {
  onRequestClose: () => void;
  onCopy: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
  text: string;
}

export default function CopyTextModal(props: CopyTextModalProps): JSX.Element {
  const ref = useRef<HTMLTextAreaElement>(null);
  useOnMount(() => {
    if (ref.current) {
      ref.current.focus();
      ref.current.select();
    }
  });

  return (
    <Modal
      enableRedesign={false}
      title={`Press ${keyboard.ctrl}-C to copy`}
      onRequestClose={props.onRequestClose}
      wrapInForm={false}
      buttons={[
        {
          text: 'Cancel',
          cancel: true,
        },
      ]}
    >
      <textarea
        ref={ref}
        style={{whiteSpace: 'pre-wrap'}}
        readOnly={true}
        value={props.text}
        onCopy={props.onCopy}
        rows={5}
      />
    </Modal>
  );
}
